import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
	selector: 'atyl-tab',
	templateUrl: './tab.component.html',
	styleUrls: ['./tab.component.scss']
})
export class TabComponent {

	@Output() close = new EventEmitter<boolean>();
	@Input() active = false;
	@Input() label: any = {};
	@Input() icon: string | null
	@Input() badge = 0;
	@Input() code: string;

}
